
import { Options, Vue } from "vue-class-component";
import Alert from "@/components/Alert.vue";
import GameBoard from "@/components/GameBoard.vue";
import GameExplanation from "@/components/GameExplanation.vue";
import { GameState, Piece } from "@/GameState";
import { playerToColor } from "@/GameVisual";
import {
  collapsePiece,
  insertClassicPiece,
  insertColorPiece,
  insertSecondColorPiece,
  insertSpacePiece,
} from "@/GameLogic";

@Options({
  props: {
    state: Object,
  },
  data() {
    return {
      gameWonShowed: false,
    };
  },
  emits: ["toMenu"],
  components: {
    Alert,
    GameBoard,
    GameExplanation,
  },
})
export default class Game extends Vue {
  state!: GameState;
  private gameWonShowed!: boolean;

  placeClassical(column: number) {
    if (!insertClassicPiece(this.state, column)) {
      (this.$refs.modal as Alert).showModal = true;
    }
  }
  placeColor(column: number) {
    if (this.state.colorPiece === undefined) {
      // first color piece
      this.state.colorPiece = insertColorPiece(this.state, column);
      if (this.state.colorPiece === undefined) {
        // illegal move
        (this.$refs.modal as Alert).showModal = true;
      }
    } else {
      // second color piece
      if (insertSecondColorPiece(this.state, column, this.state.colorPiece)) {
        this.state.colorPiece = undefined;
      } else {
        (this.$refs.modal as Alert).showModal = true;
      }
    }
  }
  placeSpace(...columns: number[]) {
    if (!insertSpacePiece(this.state, columns)) {
      (this.$refs.modal as Alert).showModal = true;
    }
  }

  manualCollapse(column: number, row: number, piece: Piece) {
    collapsePiece(this.state, column, row, piece);
  }

  getCurrentPlayerColor(player: boolean) {
    return playerToColor(player);
  }
}
